import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import API_URL from '../../config';
import axios from "axios";

const EditIncubationCenter = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        city: '',
        state: '',
        status: 'Active',
    });

    useEffect(() => {
        const fetchIncubationDetails = async () => {
            try {
                setLoading(true);

                const response = await axios.get(
                    `${API_URL}/api/incubation/incubation-get/${id}`
                );

                if (response.data.success) {
                    setFormData(response.data.data);
                } else {
                    toast.error(response.data.message || "Failed to load details");
                }
            } catch (err) {
                toast.error(
                    err.response?.data?.message || "Error fetching incubation data"
                );
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchIncubationDetails();
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            setSubmitting(true);
            const response = await fetch(`${API_URL}/api/incubation/incubation-update/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const resData = await response.json();
            if (!response.ok || resData.success === false) {
                throw new Error(resData.message || "Failed to update incubation center");
            }

            toast.success("Incubation center updated successfully!");
            navigate("/incubation/list");
        } catch (err) {
            setError(err.message || "Failed to update record");
            toast.error(err.message || "Failed to update record");
        } finally {
            setSubmitting(false);
        }
    };

    if (loading) {
        return (
            <div className="container-fluid py-5 text-center">
                <div className="spinner-border text-primary" role="status"></div>
            </div>
        );
    }

    return (
        <div className="container-fluid py-4">
            <div className="row">
                <div className="col-12">
                    <div className="card border-0 shadow-sm">
                        <div className="card-header border-bottom bg-transparent py-3">
                            <h5 className="mb-0 fw-semibold text-dark">Edit Incubation Center</h5>
                        </div>
                        <div className="card-body p-4">
                            {error && (
                                <div className="alert alert-danger mb-4" role="alert">
                                    {error}
                                </div>
                            )}
                            <form className="row g-3" onSubmit={handleSubmit}>
                                <div className="col-md-6">
                                    <label className="form-label text-secondary">Name *</label>
                                    <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label text-secondary">Email *</label>
                                    <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} required />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label text-secondary">Phone Number *</label>
                                    <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleChange} required />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label text-secondary">Status</label>
                                    <select className="form-select" name="status" value={formData.status} onChange={handleChange}>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label text-secondary">City *</label>
                                    <input type="text" className="form-control" name="city" value={formData.city} onChange={handleChange} required />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label text-secondary">State *</label>
                                    <input type="text" className="form-control" name="state" value={formData.state} onChange={handleChange} required />
                                </div>

                                <div className="col-12 d-flex justify-content-end gap-2 mt-4">
                                    <button type="button" className="btn btn-secondary" onClick={() => navigate("/incubation/list")} disabled={submitting}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary" disabled={submitting}>
                                        {submitting ? "Updating..." : "Update Incubation Center"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditIncubationCenter;